import { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';

const TeleconsultationButtons = ({ history }) => {
  return (
    <Fragment>
      <button
        className="btn-white mr5"
        data-cy="calendar"
        onClick={() => history.push('/calendar/teleconsultations?view=day')}
      >
        Calendar view
      </button>
    </Fragment>
  );
};

TeleconsultationButtons.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
};

export default withRouter(TeleconsultationButtons);
